export class ResidentSearchModel {
    id: string;
    firstName: string;
    lastName: string;
    labelName: string;
    sortName: string;
    primaryEmailAddress: string;
    additionalEmailAddress: string;
    city: string;
    state: string;
    countryCode: string;
    country: string;
    canSelect: boolean;
    notSelectableReason: string;
    defaultCredentialCode: string;
}
